import React from "react";
import { StyleSheet, useWindowDimensions, View } from "react-native";
import FullScreenLoader from "../common/FullScreenLoader";
import usePayment from "@lib/hooks/payents/usePayment";

declare global {
  interface Window {
    OneInc?: {
      PortalOne?: any;
    };
  }
}

const SelectPayorModal = ({
  onClose,
  closePayeeModal,
  containerRef,
  onError,
}: {
  onClose: () => void;
  closePayeeModal: () => void;
  onError: (error: any) => void;
  containerRef: any;
}) => {
  const { isLoading } = usePayment({
    onClose,
    closePayeeModal,
    containerRef,
    onError,
  });

  const {height} = useWindowDimensions()

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0, 
      height: height * 1.1,
      justifyContent: "center",
      alignItems: "center",
    },
  });

  return (
    <View style={styles.container}>
      {isLoading && <FullScreenLoader screenName={"Payments"} />}
    </View>
  );
};

export default SelectPayorModal;
